import React from "react";
import { FaThumbsUp, FaHeart, FaLaugh, FaSadTear } from "react-icons/fa";

const MessageReactions = ({ messageId, reactions = {}, onReact }) => {
  const reactionTypes = [
    { icon: FaThumbsUp, key: 'like', color: '#4CAF50' },
    { icon: FaHeart, key: 'love', color: '#E91E63' },
    { icon: FaLaugh, key: 'laugh', color: '#FF9800' },
    { icon: FaSadTear, key: 'sad', color: '#2196F3' }
  ];

  return (
    <div style={{
      display: 'flex',
      gap: '4px',
      marginTop: '4px',
      flexWrap: 'wrap'
    }}>
      {reactionTypes.map(({ icon: Icon, key, color }) => {
        const count = reactions[key] || 0;
        return (
          <button
            key={key}
            onClick={() => onReact(messageId, key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
              padding: '2px 6px',
              borderRadius: '12px',
              border: 'none',
              background: count > 0 ? `${color}20` : 'rgba(255,255,255,0.1)',
              color: count > 0 ? color : 'rgba(255,255,255,0.6)',
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              minWidth: '24px',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = `${color}30`;
              e.target.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = count > 0 ? `${color}20` : 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <Icon size={10} />
            {count > 0 && <span>{count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default MessageReactions; 